import React from "react"
import PropTypes from "prop-types"
import styles from "./FixedFooter.module.css"
import "./FixedFooter.css"
import { toggleClass } from "../../../utils"
import SlackButton from "../SlackButton/SlackButton"
import Button from "../Button/Button"
import { routes } from "../../../config"


let showFixedFooter = false
let height, minPageY, maxPageY = 0

class FixedFooter extends React.Component {
  state={
    demoOpen: false
  }
  componentDidMount() {
    //This can't be handled in a usual react way with a state
    //because of Gatsby mixed behavior
    if (document.getElementById("fixedFooter")) {
      window.addEventListener("scroll", this.onScroll, false)
    }
    height = Math.max(document.body.scrollHeight, document.body.offsetHeight,
      document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight)
    minPageY = 600
    maxPageY = height - 1000
    showFixedFooter = false
  }

  onScroll = () => {
    if (((window.scrollY >= minPageY && window.scrollY < maxPageY)) && !showFixedFooter) {
      showFixedFooter = true
      toggleClass("fixedFooter", "hidden")
    } else if ((window.scrollY >= maxPageY) && showFixedFooter) {
      showFixedFooter = false
      toggleClass("fixedFooter", "hidden")
    } else if ((window.scrollY < minPageY) && showFixedFooter) {
      showFixedFooter = false
      toggleClass("fixedFooter", "hidden")
    }
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.onScroll, false)
  }

  renderInnerContent = (type) => {
    switch (type) {
      case "how-it-works":
        return (
          <div className={styles.fixedFooterInner}>
            <p>Join on Slack <br/> <span>FREE now</span></p>
            <Button text={"Get Started"} link={routes.slack} isFixedFooter className={styles.fixedFooterButton}/>
          </div>
        )
      default:
        return (
          <div className={styles.fixedFooterInner}>
            <p>Join on Slack <br/> <span>FREE now</span></p>
            <div className={styles.buttonsWrapper}>
              <SlackButton />
              <Button text={"Free Demo"} link={"/"} isFixedFooter/>
            </div>
          </div>
        )
    }
  }

  render() {
    return (
      <section className={`${styles.fixedFooter} hidden`} id='fixedFooter'>
        {this.renderInnerContent(this.props.type)}
      </section>
    )
  }
}


FixedFooter.propTypes = {
  type: PropTypes.string,
}

export default FixedFooter